// Rapid-annotate VLM state of an element (server: services/vlmClassifyService.js
// writes metadata.vlm). Shared by the canvas, side pane and toolbar so the
// colours and meanings stay in one place.
//
//   pending — placed, Claude is classifying it
//   review  — Claude answered; waiting for the human confirm
//   failed  — Claude couldn't classify it; retry available
//   null    — not a rapid-annotated element, or already confirmed/rejected
// Confirmed and rejected always win, so these never mask the normal states.

export const VLM_COLORS = {
  pending: '#a78bfa',
  review: '#f5a524',
  failed: '#f472b6',
};

export const VLM_LABELS = {
  pending: 'DETECTING…',
  review: 'TO REVIEW',
  failed: 'DETECTION FAILED',
};

// Re-queue a classification that never came back (e.g. server restarted mid-request).
export const VLM_STALE_PENDING_MS = 2 * 60 * 1000;

export function getVlmState(element) {
  const vlm = element?.metadata?.vlm;
  if (!vlm || element.confirmed || element.metadata?.rejected) return null;
  if (vlm.status === 'pending') return 'pending';
  if (vlm.status === 'failed') return 'failed';
  if (vlm.status === 'done') return 'review';
  return null;
}

export function isStalePending(element, now = Date.now()) {
  const vlm = element?.metadata?.vlm;
  if (vlm?.status !== 'pending') return false;
  const requested = Date.parse(vlm.requested_at);
  return !Number.isFinite(requested) || now - requested > VLM_STALE_PENDING_MS;
}
